var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.94474914 22v-8.8342474h-2.94474914v-3.68093646h2.94474914v-2.94474915c0-3.04266205 1.92660216-4.54006699 4.64092466-4.54006699 1.3001067 0 2.417639.09717672 2.7430338.13987558v3.18032908l-1.8824309.00073619c-1.4760555 0-1.8205911.70158648-1.8205911 1.73077631v2.43309898h3.6809364l-.7361873 3.68093646h-2.9447491l.058895 8.8342474",
    fill: "#3b5998",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook2.71d0ddd0e8b7b33c00bef3642bebcd71.svg";
export { ForwardRef as ReactComponent };